import React from 'react';
import { Link } from 'gatsby';
import classnames from 'classnames';
import Icon from 'components/UI/Icon';
import useIntersection from 'hooks/useIntersection';
import * as styles from './connect.module.scss';

const Connect = ({ data }) => {
  const { scrollWrapper, inViewSec, inViewRefSec } = useIntersection({
    threshold: 0.5,
  });

  return (
    <section className={classnames(styles.section)} ref={scrollWrapper}>
      <div className="cr-wrap">
        <div
          className={classnames(styles.inner, inViewSec && styles.jsAnimInit)}
          ref={inViewRefSec}
        >
          <div className={classnames(styles.content)}>
            <h2 className={classnames(styles.title, 'cr-h2')}>
              Become a friend of C<span className="cr-main">i</span>RRUS!
            </h2>
            <p className={classnames('cr-lead')}>
              {data.description && data.description}
            </p>
          </div>

          <Link
            to={'#'}
            className={classnames(
              'cr-btn cr-btn--white cr-btn--connect cr-btn--connect-blue',
              styles.btn
            )}
          >
            {data.button.icon && <Icon name={data.button.icon} />}
            <span>{data.button.text && data.button.text}</span>
            <i></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Connect;
